export default {
  // Truncates any number
  truncate: (num) => parseFloat(num).toString(),
  // Transforms number to comma separated string
  humanReadable: (num) => (!num ? num : num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')),
};
